import { selectIssueTypeById, selectIssueTypeFieldsById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { issueTypeFieldsRevisionSettingsDetailViewStaticData } from "src/views/IssueTypeFieldsRevisionSettingsDetailView/constants"
import { IssueTypeFieldsRevisionSettingsDetailView } from "src/views/IssueTypeFieldsRevisionSettingsDetailView/IssueTypeFieldsRevisionSettingsDetailView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/revisions/$issueTypeFieldsId",
)({
	component: IssueTypeFieldsRevisionSettingsDetailView,
	staticData: issueTypeFieldsRevisionSettingsDetailViewStaticData,
	loader: ({ params }) => {
		const issueType = selectIssueTypeById(params.issueTypeId)(appStore.getState())
		const issueTypeFields = selectIssueTypeFieldsById(params.issueTypeFieldsId)(appStore.getState())

		if (!issueType || !issueTypeFields || issueTypeFields.issue_type !== issueType.uuid) throw notFound()
	},
})
